import { useEffect } from 'react';
import { Component, ComponentTypes } from '../../../common/componentUtils';

export const useOverlayKeyDownEvents = (
	pageRef: any,
	componentsToEdit: Component[],
	handleComponentUpdate: (components: Component[], task?: string) => void,
	setComponentsToEdit: (comp: Component[]) => void,
	uItems: Component[]
) => {
	// sets up a keydown event listener that listens for the delete and arrow keys
	useEffect(() => {
		function handleKeyDown(event) {
			if (
				!componentsToEdit ||
				componentsToEdit.length === 0 ||
				event.target.nodeName === 'INPUT' ||
				event.target.nodeName === 'TEXTAREA' ||
				(componentsToEdit.length > 1 &&
					event.key !== 'Backspace' &&
					event.key !== 'Delete' &&
					event.key !== 'Escape') // Disabling KeyDown handler other than Delete and Escape when multiple fields are selected TODO: Handle Keydown for multi select fields
			) {
				return;
			}
			event.preventDefault();

			const componentForEdit = componentsToEdit[0];

			const updatedComponent = { ...componentForEdit };
			const { height: pageHeight, width: pageWidth } =
				pageRef.current.getBoundingClientRect();

			switch (event.key) {
				case 'Backspace':
				case 'Delete':
					if (componentForEdit.type === ComponentTypes.CheckGroupComponent) {
						const checkobxGroupComponents = uItems.filter(
							comp =>
								comp.groupId === componentForEdit.groupId &&
								comp.groupId === componentForEdit.groupId
						);
						handleComponentUpdate(checkobxGroupComponents, 'delete');
					} else {
						handleComponentUpdate([componentForEdit], 'delete');
					}

					setComponentsToEdit([]);
					break;
				case 'ArrowUp':
					updatedComponent.y = Math.max(
						0,
						(componentForEdit.y * pageHeight - 1) / pageHeight
					);
					handleComponentUpdate([updatedComponent]);
					break;
				case 'ArrowRight':
					const scaledX = componentForEdit.x * pageWidth + 1;
					const componentWidth = updatedComponent.width * pageWidth;
					if (scaledX + componentWidth > pageWidth) {
						break;
					}
					updatedComponent.x = scaledX / pageWidth;
					handleComponentUpdate([updatedComponent]);
					break;
				case 'ArrowDown':
					const scaledY = componentForEdit.y * pageHeight + 1;
					const componentHeight = updatedComponent.height * pageHeight;
					if (scaledY + componentHeight > pageHeight) {
						break;
					}
					updatedComponent.y = scaledY / pageHeight;
					handleComponentUpdate([updatedComponent]);
					break;
				case 'ArrowLeft':
					updatedComponent.x = Math.max(
						0,
						(componentForEdit.x * pageWidth - 1) / pageWidth
					);
					handleComponentUpdate([updatedComponent]);
					break;
			}
		}

		document.addEventListener('keydown', handleKeyDown);
		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [componentsToEdit, handleComponentUpdate, setComponentsToEdit, uItems, pageRef]);
};
